import React from 'react';

function ScoreConnector(): React.JSX.Element {
    return <hr className="border-border m-0 flex-[0.5] p-0" />;
}

export default ScoreConnector;
